'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Camera;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Camera(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 24 24',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M9.3,4 L14.7,4 L16.347,5.77777778 L19.2,5.77777778 C20.19,5.77777778 21,6.57777778 21,7.55555556 L21,18.2222222 C21,19.2 20.19,20 19.2,20 L4.8,20 C3.81,20 3,19.2 3,18.2222222 L3,7.55555556 C3,6.57777778 3.81,5.77777778 4.8,5.77777778 L7.653,5.77777778 L9.3,4 Z M12,17.3333333 C14.484,17.3333333 16.5,15.3422222 16.5,12.8888889 C16.5,10.4355556 14.484,8.44444444 12,8.44444444 C9.516,8.44444444 7.5,10.4355556 7.5,12.8888889 C7.5,15.3422222 9.516,17.3333333 12,17.3333333 Z M12,15.5555556 C13.4911688,15.5555556 14.7,14.3616482 14.7,12.8888889 C14.7,11.4161296 13.4911688,10.2222222 12,10.2222222 C10.5088312,10.2222223 9.30000006,11.4161296 9.30000006,12.8888889 C9.30000006,14.3616482 10.5088312,15.5555555 12,15.5555556 L12,15.5555556 Z'
  }));
}
Camera.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};